export const MEMBERSHIP_PACKAGES = [
  {
    id: 'PRO_1T',
    name: 'TamCare Pro (1 Tháng)',
    cost: 119000,
    tier: 'pro',
    popular: true,
    features: [
      'Toàn bộ tính năng (ngoài gói Miễn phí)',
      'Lịch uống thuốc & nhắc nhở',
      'Theo dõi chỉ số & cảnh báo sức khỏe',
      'Điểm danh sinh tồn hàng ngày',
      'Trợ lý AI & đánh giá rủi ro',
      'Gọi khẩn cấp',
    ],
  },
];

export const FREE_TIER_FEATURES = [
  'Xem bài viết (blog)',
  'Lưu trữ hồ sơ bệnh án',
  'Mua hàng cửa hàng TamCare',
];

export function formatVnd(value) {
  return `${new Intl.NumberFormat('vi-VN').format(Number(value || 0))} đ`;
}

/** @deprecated use formatVnd */
export function formatPoints(value) {
  return formatVnd(value);
}

const TIER_LABEL_MAP = {
  Pro: 'Pro',
  PRO: 'Pro',
  pro: 'Pro',
  Basic: 'Pro',
  Premium: 'Pro',
  BASIC: 'Pro',
  PREMIUM: 'Pro',
  basic: 'Pro',
  premium: 'Pro',
  'Miễn phí': 'Miễn phí',
  Thường: 'Miễn phí',
  'Chưa có gói': 'Miễn phí',
};

export function normalizeTierLabel(label) {
  if (!label) return 'Miễn phí';
  return TIER_LABEL_MAP[label] || label;
}

export function packageTierLabel() {
  return 'Pro';
}

export function mergePackagesFromApi(apiPackages) {
  if (!Array.isArray(apiPackages) || apiPackages.length === 0) {
    return MEMBERSHIP_PACKAGES;
  }
  return MEMBERSHIP_PACKAGES.map((local) => {
    const remote = apiPackages.find((p) => p.id === local.id);
    if (!remote) return local;
    return {
      ...local,
      cost: Number(remote.cost ?? local.cost),
      popular: remote.popular ?? local.popular,
    };
  });
}

export function memberLevelLabel(level) {
  if (Number(level) >= 1) return 'Pro';
  return 'Miễn phí';
}

export function previewOrderAmount(elderlyMembership, packageId) {
  const pkg = MEMBERSHIP_PACKAGES.find((p) => p.id === packageId);
  if (!pkg) return 0;

  const active = elderlyMembership?.hasMembership
    && elderlyMembership?.expiresAt
    && new Date(elderlyMembership.expiresAt) > new Date();

  if (!active) return pkg.cost;
  return pkg.cost;
}
